<div class="">
    <mat-toolbar class="justify-content-center" color="primary">
        <div class="mat-headline">
           Customer Bank Account Setup
        </div>
    </mat-toolbar>
    <form [formGroup]="customerBankAccountSetup.customerBankAccountSetupForm">
        <mat-grid-list cols="2" >
            <mat-grid-tile>
                 <div class="adminControls">
                    <!-- <input type="hidden" formControlName="_id"> -->
                    <mat-form-field appearance="outline">
                        <mat-label>Acount Holder Name: </mat-label>
                        <input matInput formControlName="acountHolderName" required>
                        <!-- <mat-error>This feild is required</mat-error> -->
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label> Bank Account Number: </mat-label>
                        <input matInput formControlName="bankAccountNumber" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Bank Routing Number: </mat-label>
                        <input matInput formControlName="bankRoutingNumber" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Bank Account Type: </mat-label>
                        <input matInput formControlName="bankAccountType" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Contact Name: </mat-label>
                        <input matInput formControlName="contactName" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Bank Phone: </mat-label>
                        <input matInput formControlName="bankPhone" required>
                    </mat-form-field>
                 </div>
            </mat-grid-tile>
            
            <mat-grid-tile>
                <div class="adminControls">
                    <mat-form-field appearance="outline">
                        <mat-label> Bank Street: </mat-label>
                        <input matInput formControlName="bankstreet" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Bank City: </mat-label>
                        <input matInput formControlName="bankcity" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Bank State: </mat-label>
                        <input matInput formControlName="bankstate" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Bank Zipcode: </mat-label>
                        <input matInput formControlName="bankzipcode" required>
                    </mat-form-field>
                  
                    <div class="buttonRow">
                        <button mat-raised-button color="primary" type="submit" (click)="onSubmit()">Register</button>
                        <button mat-raised-button color="warn" type="button">Reset</button>
                    </div>
                </div>
           </mat-grid-tile>
        </mat-grid-list>
    </form>
</div>

